import * as React from 'react'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const styles = ({ COLORS }) => ({
  checkmarkCircle: {
    strokeDasharray: '166',
    strokeDashoffset: '166',
    strokeWidth: '2',
    strokeMiterlimit: '10',
    stroke: COLORS.GREEN.NORMAL,
    fill: 'none',
    animation: 'stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards'
  },
  checkmark: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    display: 'block',
    strokeWidth: '2',
    stroke: '#fff',
    strokeMiterlimit: '10',
    margin: '10% auto',
    boxShadow: `inset 0px 0px 0px ${COLORS.GREEN.NORMAL}`
  },
  ready: {
    animation: 'fill .4s ease-in-out forwards, scale .3s ease-in-out .5s both',
    '& $checkmarkCheck': {
      animation: 'stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.4s forwards'
    }
  },
  checkmarkCheck: {
    transformOrigin: '50% 50%',
    strokeDasharray: '48',
    strokeDashoffset: '48'
  },
  '@keyframes stroke': {
    '100%': {
      strokeDashoffset: '0'
    }
  },
  '@keyframes scale': {
    '0%, 100%': {
      transform: 'none'
    },
    '50%': {
      transform: 'scale3d(1.1, 1.1, 1)'
    }
  },
  '@keyframes fill': {
    '100%': {
      boxShadow: `inset 0px 0px 0px 30px ${COLORS.GREEN.NORMAL}`
    }
  }
})

const SvgComponent = injectSheet(styles)(({ classes, ready, ...props }) => {
  return (
    <svg
      className={classNames(classes.checkmark, { [classes.ready]: ready })}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
      {...props}>
      <circle
        className={classes.checkmarkCircle}
        cx={26}
        cy={26}
        r={25}
        fill="none"
      />
      <path
        className={classes.checkmarkCheck}
        fill="none"
        d="M14.1 27.2l7.1 7.2 16.7-16.8"
      />
    </svg>
  )
})

export default SvgComponent
